import React from "react";

export default function Header(props: any) {
    const headerConfig = props.headerConfig;

    return (
        <div id="kt_header" className="header"/>
    )
}
